// SENT product page: gift-message character counter + mobile sticky Add to Bag bar.
(function () {
  document.querySelectorAll('.product-form__gift-message textarea').forEach(function (textarea) {
    var wrapper = textarea.closest('.product-form__gift-message');
    var counter = wrapper && wrapper.querySelector('.product-form__gift-message-counter-current');
    if (!counter) return;
    var update = function () {
      counter.textContent = textarea.value.length;
    };
    textarea.addEventListener('input', update);
    update();
  });

  var submitButton = document.querySelector('[id^="MainProduct-"] .product-form__submit');
  var stickyBar = document.querySelector('.product-sticky-bar');
  if (!submitButton || !stickyBar) return;

  var stickyButton = stickyBar.querySelector('.product-sticky-bar__button');
  var stickyLabel = stickyButton && stickyButton.querySelector('span');

  if (stickyButton) {
    stickyButton.addEventListener('click', function () {
      submitButton.click();
    });

    var syncState = function () {
      stickyButton.disabled = submitButton.disabled;
      var sourceLabel = submitButton.querySelector('span');
      if (stickyLabel && sourceLabel) stickyLabel.textContent = sourceLabel.textContent;
    };
    syncState();
    new MutationObserver(syncState).observe(submitButton, {
      attributes: true,
      attributeFilter: ['disabled'],
      subtree: true,
      characterData: true,
      childList: true,
    });
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('product-sticky-bar--visible', entry.boundingClientRect.top < 0);
      });
    },
    { threshold: 0 }
  );
  observer.observe(submitButton);
})();

/* sent-combos */
document.addEventListener('change', function (e) {
  var vs = e.target.closest && e.target.closest('variant-selects');
  if (!vs || !vs.querySelector('.sent-type-picker')) return;
  var script = vs.querySelector('[data-sent-combos]'); if (!script) return;
  var combos; try { combos = JSON.parse(script.textContent); } catch (_) { return; }
  var typeEl = vs.querySelector('.sent-type-picker input:checked');
  var sizeSel = vs.querySelector('.sent-size-picker select');
  var frames = vs.querySelectorAll('.sent-frame-picker input');
  if (!typeEl || !sizeSel) return;
  var type = typeEl.value, size = sizeSel.value;
  var frameEl = vs.querySelector('.sent-frame-picker input:checked');
  var frame = frameEl ? frameEl.value : 'No frame';
  var has = function (t, s, f) { return combos.some(function (c) { return c[0] === t && c[1] === s && c[2] === f; }); };
  if (!has(type, size, 'No frame')) {
    var sizes = combos.filter(function (c) { return c[0] === type && c[2] === 'No frame'; }).map(function (c) { return c[1]; });
    var all = [].map.call(sizeSel.options, function (o) { return o.value; });
    var ok = all.filter(function (s) { return sizes.indexOf(s) > -1; });
    if (e.target === sizeSel) return;
    var idx = all.indexOf(size), pick = ok.filter(function (s) { return all.indexOf(s) >= idx; })[0] || ok[ok.length - 1];
    if (pick) { [].forEach.call(sizeSel.options, function (o) { var on = o.value === pick; o.selected = on; if (on) o.setAttribute('selected', 'selected'); else o.removeAttribute('selected'); }); size = pick; }
  }
  if (!has(type, size, frame)) {
    [].forEach.call(frames, function (r) { r.checked = r.value === 'No frame'; });
  }
}, true);

/* sent-units */
(function () {
  var INCH = { '13,18': '5 x 7', '21,30': '8 x 12', '30,40': '12 x 16', '40,50': '16 x 20', '50,70': '20 x 28', '70,100': '28 x 40', '100,150': '40 x 60' };
  var unit = 'cm';
  try { unit = localStorage.getItem('sentUnit') === 'in' ? 'in' : 'cm'; } catch (_) {}
  function apply() {
    document.querySelectorAll('.sent-size-picker').forEach(function (box) {
      [].forEach.call(box.querySelectorAll('option'), function (o) {
        var m = o.value.match(/^(\d+) x (\d+) cm$/); if (!m) return;
        var key = [Math.min(+m[1], +m[2]), Math.max(+m[1], +m[2])].join(',');
        var inch = INCH[key], txt = o.value;
        if (unit === 'in' && inch) { var p = inch.split(' x '); txt = (+m[1] < +m[2] ? inch : p[1] + ' x ' + p[0]) + ' in'; }
        if (o.textContent !== txt) o.textContent = txt;
      });
      [].forEach.call(box.querySelectorAll('.sent-unit-toggle button'), function (b) {
        b.classList.toggle('is-active', b.dataset.unit === unit);
      });
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.sent-unit-toggle button'); if (!b) return;
    unit = b.dataset.unit; try { localStorage.setItem('sentUnit', unit); } catch (_) {}
    apply();
  });
  new MutationObserver(function () { apply(); }).observe(document.documentElement, { childList: true, subtree: true });
  apply();
})();


/* sent-guide */
document.addEventListener('click', function (e) {
  var b = e.target.closest && e.target.closest('.sent-ruler'); if (!b) return;
  var sel = document.querySelector('.sent-size-picker select'); if (!sel) return;
  var INCH = { '13,18': '5 x 7', '21,30': '8 x 12', '30,40': '12 x 16', '40,50': '16 x 20', '50,70': '20 x 28', '70,100': '28 x 40', '100,150': '40 x 60' };
  var rows = [].map.call(sel.options, function (o) {
    var m = o.value.match(/^(\d+) x (\d+) cm$/); if (!m) return '';
    var key = [Math.min(+m[1], +m[2]), Math.max(+m[1], +m[2])].join(','), inch = INCH[key] || '';
    if (inch && +m[1] > +m[2]) inch = inch.split(' x ').reverse().join(' x ');
    return '<tr><td>' + o.value + '</td><td>' + inch + ' in</td></tr>';
  }).join('');
  var d = document.getElementById('sent-guide') || document.body.appendChild(Object.assign(document.createElement('dialog'), { id: 'sent-guide', className: 'sent-guide' }));
  d.innerHTML = '<div class="sent-guide__inner"><h3>Size guide</h3><table><tr><th>Centimetres</th><th>Inches</th></tr>' + rows + '</table><button type="button" onclick="this.closest(\'dialog\').close()">Close</button></div>';
  d.showModal();
});

/* sent-frame-nav */
document.addEventListener('click', function (e) {
  var b = e.target.closest && e.target.closest('.sent-frame-nav'); if (!b) return;
  var list = b.closest('.sent-frame-picker').querySelector('.sent-frame-list');
  list.scrollBy({ left: (b.classList.contains('sent-frame-nav--next') ? 1 : -1) * 280, behavior: 'smooth' });
});

/* sent-frame-note */
(function () {
  function upd() {
    var n = document.querySelector('[data-frame-note]'), f = document.querySelector('.sent-frame-picker input:checked');
    if (!n || !f) return;
    n.textContent = f.value === 'No frame' ? 'Frame not included.' : f.value + ' frame included.';
  }
  document.addEventListener('change', function () { setTimeout(upd, 80); setTimeout(upd, 1300); });
  document.addEventListener('DOMContentLoaded', upd); setTimeout(upd, 800);
})();
